import React, { memo } from "react";

import {
  FlamebearerMetrics,
  getProfileTypeColor,
  getProfileTypeLightColor,
  ProfileType
} from "@platformsh/observability-graph/ContinuousProfiling";

import Dialog from "ds/Dialog";
import * as Table from "ds/Table";

import FlamebearerCallTooltip from "../FlamebearerCallTooltip";

import * as S from "./styles";

type Props = {
  callMetrics: FlamebearerMetrics;
  profileType: ProfileType;
};

const FlamebearerTableRow = ({ callMetrics, profileType }: Props) => {
  return (
    <Dialog
      align="center"
      trigger={
        <S.Tr>
          <Table.Td width="calc(100% - 180px)">
            {callMetrics.call.label}
          </Table.Td>
          <Table.Td width="180px">
            <S.Progress>
              <S.ProgressBar
                color={getProfileTypeLightColor(profileType.name)}
                zIndex={2}
                width={Math.round(callMetrics.inclusive.impact * 100)}
              />
              <S.ProgressBar
                color={getProfileTypeColor(profileType.name)}
                zIndex={
                  callMetrics.exclusive.impact <= callMetrics.inclusive.impact
                    ? 3
                    : 1
                }
                width={Math.round(callMetrics.exclusive.impact * 100)}
              />
            </S.Progress>
          </Table.Td>
        </S.Tr>
      }
      link={
        <FlamebearerCallTooltip
          callMetrics={callMetrics}
          profileType={profileType}
        />
      }
    />
  );
};

export default memo(FlamebearerTableRow);
